import { useCallback } from "react"

const CF_ACCESS_LOGOUT = "/cdn-cgi/access/logout"
const LANDING_URL = "https://civalaos.com"

export function useLogout() {
  return useCallback(() => {
    void fetch(CF_ACCESS_LOGOUT, { redirect: "manual", credentials: "same-origin" }).finally(() => {
      window.location.href = LANDING_URL
    })
  }, [])
}
